import { withEnhancedRouter } from '~/core/compose'

import ChatscriptMessagesModal from './ChatscriptMessagesModal'

export default withEnhancedRouter(ChatscriptMessagesModal)
